import {
  SET_PREFERENCES,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  basePreferences: [],
}

function setPreferences(state, action) {
  return {
    ...state,
    basePreferences: action.payload.basePreferences,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PREFERENCES:
      return setPreferences(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
